import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="not-found">
      <h1>{t("404_title")}</h1>
      <p>{t("404_redirect_message")}</p>
    </div>
  );
};

export default NotFound;
